<script>
import TablaDetalleCargoPersonal from "./TablaDetalleCargoPersonal";
import TablaDetalleHistorialSolicitud from "./TablaDetalleHistorialSolicitud";
import TablaDetalleDefault from "./TablaDetalleDefault";

export default {
  name: "TablaBaseDetalle",
  functional: true,
  render: function (createElement, context) {
    function setRenderDetalle () {
      var objetoLocal = context.props.objeto;
      var detallerenderLocal = context.props.detallerender;
      if (detallerenderLocal === 'cargopersonal') return TablaDetalleCargoPersonal;
      if (detallerenderLocal === 'historialsolicitud') return TablaDetalleHistorialSolicitud;
      return TablaDetalleDefault;
    }

    return createElement(setRenderDetalle(), { props: context.props }, context.children)
  },
  props: {
    objeto: Object,
    detallerender: String
  },
  data() {
    return {
    }
  },
  methods: {
  }

};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/TablaBaseDetalle.vue